import { NgModule } from '@angular/core';
import {
  BsDatepickerModule,
  BsDatepickerConfig
} from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

const bootstrapModules = [BsDatepickerModule, TimepickerModule];

@NgModule({
  imports: [
    BsDatepickerModule,
    TimepickerModule
  ],
  exports: [...bootstrapModules],
  providers: [
    {
      provide: BsDatepickerConfig,
      useValue: {
        dateInputFormat: 'DD.MM.YYYY'
      }
    }
  ]
})
export class CustomBootstrapModule {}
